import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Range } from "react-range";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import Products from "../components/products/Products";
import { AiFillStar } from "react-icons/ai";
import { CiStar } from "react-icons/ci";
import { BsFillGridFill } from "react-icons/bs";
import { FaThList } from "react-icons/fa";
import ShopProducts from "../components/products/ShopProducts";
import Pagination from "../components/Pagination";
import {
  price_range_product,
  query_products,
} from "../store/reducers/homeReducer";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox } from "../components/ui/checkbox";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
import { Filter, LayoutGrid, LayoutList } from "lucide-react";
import { Button } from "../components/ui/button";
const CategoryShops = () => {
  let [searchParams, setSearchParams] = useSearchParams();
  const category = searchParams.get("category");
  const { products, totalProduct, latest_product, priceRange, parPage } =
    useSelector((state) => state.home);

  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(1);
  const [styles, setStyles] = useState("grid");
  const [filter, setFilter] = useState(true);
  const [state, setState] = useState({
    values: [priceRange.low, priceRange.high],
  });
  const [rating, setRatingQ] = useState("");
  const [sortPrice, setSortPrice] = useState("");

  useEffect(() => {
    dispatch(price_range_product());
  }, []);
  useEffect(() => {
    setState({
      values: [
        priceRange.low,
        priceRange.high === priceRange.low
          ? priceRange.high + 1
          : priceRange.high,
      ],
    });
  }, [priceRange]);

  useEffect(() => {
    dispatch(
      query_products({
        low: state.values[0] || "",
        high: state.values[1] || "",
        category,
        rating,
        sortPrice,
        pageNumber,
      })
    );
  }, [
    state.values[0],
    state.values[1],
    category,
    rating,
    pageNumber,
    sortPrice,
  ]);

  const resetRating = () => {
    setRatingQ("");
    dispatch(
      query_products({
        low: state.values[0],
        high: state.values[1],
        category,
        rating: "",
        sortPrice,
        pageNumber,
      })
    );
  };
  return (
    <div>
      <Headers />
      <section
        className="h-[220px] bg-cover bg-no-repeat relative bg-left"
        style={{
          backgroundImage: `url(${process.env.REACT_APP_URL}/images/banner/bannergroceries_second.jpg)`,
        }}
      >
        <div className="absolute left-0 top-0 w-full h-full bg-[#0000008a]">
          <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white">
              <h2 className="text-3xl font-bold">Omah Global</h2>
              <div className="flex justify-center items-center gap-2 text-2xl w-full">
                <Link to="/">Home</Link>
                {category && (
                  <>
                    <span className="pt-1">
                      <MdOutlineKeyboardArrowRight />
                    </span>
                    <span>{category}</span>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-5">
        <div className="w-[85%] md:w-[90%%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
          <div className={`md:block hidden ${!filter ? "mb-6" : "mb-2"}`}>
            <Button
              onClick={() => setFilter(!filter)}
              className="text-center w-full py-2 px-3text-black"
            >
              Filter items
            </Button>
          </div>
          <div className="w-full flex flex-wrap">
            <div
              className={`w-3/12 md-lg:w-4/12 md:w-full pr-8 ${
                filter
                  ? "md:h-0 md:overflow-hidden md:mb-6"
                  : "md:h-auto md:overflow-auto md:mb-0 p-3 py-0 pb-10"
              }`}
            >
              <div className="py-0 flex flex-col gap-5">
                <h2 className="text-[18px] font-bold mb-2 text-gray-500">
                  Price
                </h2>
                <Range
                  className="w-[300px]"
                  step={1}
                  min={priceRange.low}
                  max={
                    priceRange.high === priceRange.low
                      ? priceRange.high + 1
                      : priceRange.high
                  }
                  values={state.values}
                  onChange={(values) => setState({ values })}
                  renderTrack={({ props, children }) => (
                    <div
                      {...props}
                      className="w-full h-[6px] bg-gray-200 rounded-full cursor-default"
                    >
                      {children}
                    </div>
                  )}
                  renderThumb={({ props, index }) => (
                    <div
                      {...props}
                      className={`w-[15px] h-[15px] rounded-full ${
                        index === 0 ? "bg-[#757575]" : "bg-[#757575]"
                      }`}
                    />
                  )}
                />

                <div>
                  <span className="text-gray-900 text-[18px] font-bold text-lg">
                    ${Math.floor(state.values[0])} - $
                    {Math.floor(state.values[1])}
                  </span>
                </div>
              </div>
              <div className="py-3 flex flex-col gap-4">
                <h2 className="text-[18px] font-bold mb-2 text-gray-500">
                  Rating
                </h2>
                <div className="flex flex-col gap-3">
                  <div className="flex items-center space-x-2">
                    <Checkbox onClick={() => setRatingQ(5)} id="5" />
                    <label
                      htmlFor="5"
                      className="text-sm text-gray-700 font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                    >
                      5 stars
                    </label>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Checkbox onClick={() => setRatingQ(4)} id="4" />
                    <label
                      htmlFor="4"
                      className="text-sm text-gray-700 font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                    >
                      4 stars
                    </label>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Checkbox onClick={() => setRatingQ(3)} id="3" />
                    <label
                      htmlFor="3"
                      className="text-sm text-gray-700 font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                    >
                      3 stars
                    </label>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Checkbox onClick={() => setRatingQ(2)} id="2" />
                    <label
                      htmlFor="2"
                      className="text-sm text-gray-700 font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                    >
                      2 stars
                    </label>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Checkbox onClick={() => setRatingQ(1)} id="1" />
                    <label
                      htmlFor="1"
                      className="text-sm text-gray-700 font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                    >
                      1 star
                    </label>
                  </div>
                </div>
              </div>
              <div className="py-5 flex flex-col gap-4 md:hidden">
                <Products title="Latest Products" products={latest_product} />
              </div>
            </div>
            <div className="w-9/12 md-lg:w-8/12 md:w-full">
              <div className="pl-8 md:pl-0">
                <div className="py-0 mb-10  rounded-md flex justify-between items-start">
                  <h2 className="text-lg font-medium text-gray-900">
                    {totalProduct} Products
                  </h2>
                  <div className="flex justify-center items-center gap-3">
                    <Select onValueChange={(value) => setSortPrice(value)}>
                      <SelectTrigger className="w-full">
                        <SelectValue placeholder="Sort By" />
                      </SelectTrigger>
                      <SelectContent className="nex_drop">
                        <SelectItem
                          value="low-to-high"
                          className="hover:text-white cursor-pointer"
                        >
                          Low to High Price
                        </SelectItem>
                        <SelectItem
                          value="high-to-low"
                          className="hover:text-white cursor-pointer"
                        >
                          High to Low Price
                        </SelectItem>
                      </SelectContent>
                    </Select>
                    <div className="flex justify-center items-start gap-4 md-lg:hidden">
                      <div
                        onClick={() => setStyles("grid")}
                        className={`p-2 ${
                          styles === "grid" && "bg-gray-200"
                        } text-gray-700 cursor-pointer rounded-sm`}
                      >
                        <LayoutGrid size={18} />
                      </div>
                      <div
                        onClick={() => setStyles("list")}
                        className={`p-2 ${
                          styles === "list" && "bg-gray-200"
                        } text-gray-700 cursor-pointer rounded-sm`}
                      >
                        <LayoutList size={18} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pb-8">
                  <ShopProducts products={products} styles={styles} />
                </div>
                <div>
                  {totalProduct > parPage && (
                    <Pagination
                      pageNumber={pageNumber}
                      setPageNumber={setPageNumber}
                      totalItem={totalProduct}
                      parPage={parPage}
                      showItem={Math.floor(totalProduct / parPage)}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default CategoryShops;
